<!-- class students list -->
<template>
  <div class="content has_breadcrumb journal-inner">
    <GgPage pageType="" title="Journal">
      <div slot="topAppBar">
        <search :query="query" />
      </div>
      <div class="journal-list-inner">
        <div class="journal-create-main">
          <div class="journal-top-fixed">
            <div class="title">Search Results</div>
          </div>

          <div class="journal-page-main" v-loading="loading">
            <div class="journal-page-list">
              <div
                class="journal-list-box-inner"
                v-infinite-scroll="loadJournal"
                v-if="list.length > 0"
              >
                <div class="journal-box" v-for="(item, index) in list" :key="index">
                  <div
                    class="journal-img"
                    :class="{ 'pdf-journal-img': isPdfNewsletter(item) }"
                    :style="getJournalCoverStyle(item)"
                  >
                    <template v-if="isPdfNewsletter(item)">
                      <span class="pdf-chip">PDF</span>
                      <div class="pdf-thumbnail-pages" v-if="getPdfThumbnailImages(item).length">
                        <img
                          v-for="(image, imageIndex) in getPdfThumbnailImages(item)"
                          :key="imageIndex"
                          :src="pdfThumbPath(image)"
                        />
                      </div>
                    </template>
                    <el-tooltip
                      v-if="item.pdfFailed"
                      effect="dark"
                      placement="top"
                      popper-class="journal-pdf-state-tooltip journal-pdf-failure-tooltip"
                      :visible-arrow="false"
                    >
                      <div slot="content">
                        The {{ item.newsletter ? 'newsletter' : 'portfolio' }}'s processing failed.
                        Please click Approve to try again.
                      </div>
                      <span
                        class="pdf-state-badge failed"
                        @click.stop
                        aria-label="PDF generation failed"
                        >!</span
                      >
                    </el-tooltip>
                    <el-tooltip
                      v-else-if="item.pdfGenerating"
                      effect="dark"
                      placement="top"
                      popper-class="journal-pdf-state-tooltip journal-pdf-generating-tooltip"
                      :visible-arrow="false"
                    >
                      <div slot="content">
                        The {{ item.newsletter ? 'newsletter' : 'portfolio' }} is being processed.
                        It will be posted once completed.
                      </div>
                      <span
                        class="pdf-state-badge"
                        @click.stop
                        aria-label="PDF generation in progress"
                      >
                        <i class="el-icon-more"></i>
                      </span>
                    </el-tooltip>
                  </div>
                  <div class="journal-tit" :title="item.title">{{ item.title }}</div>
                  <div class="journal-tag" v-if="item.newsletter">All students</div>
                  <div class="journal-tag" v-if="!item.newsletter && item.recipientInfo">
                    <div class="avatar" v-if="item.recipientInfo.photo">
                      <img :src="item.recipientInfo.photo" />
                    </div>
                    <div class="no" v-else>
                      {{
                        item.recipientInfo.firstName
                          ? item.recipientInfo.firstName.substring(0, 1).toUpperCase()
                          : '-'
                      }}{{
                        item.recipientInfo.lastName
                          ? item.recipientInfo.lastName.substring(0, 1).toUpperCase()
                          : '-'
                      }}
                    </div>
                    <div class="name">
                      {{
                        item.recipientInfo.firstName || '' + ' ' + item.recipientInfo.lastName || ''
                      }}
                    </div>
                  </div>
                  <div class="journal-col">
                    <gg-menu-bar>
                      <i class="iconmore_vert-24px iconfont" />
                      <template slot="menus">
                        <gg-menu-bar-item
                          v-if="
                            item.status === 'DRAFT' ||
                            item.status === 'PENDING' ||
                            item.status === 'POSTED'
                          "
                          @click="toPreview(item.id, item.newsletter ? 0 : 1, item)"
                        >
                          <span>Preview</span>
                        </gg-menu-bar-item>

                        <gg-menu-bar-item
                          v-if="item.status === 'DRAFT' && hasPermission('Share journals_Create')"
                          @click="journalSubmitShow(item.id, item.newsletter ? 0 : 1, item)"
                        >
                          <span>Submit</span>
                        </gg-menu-bar-item>

                        <gg-menu-bar-item
                          v-if="canShowJournalUndo(item)"
                          @click="journalUndoShow(item.id, item.newsletter ? 0 : 1, item)"
                        >
                          <span>Undo</span>
                        </gg-menu-bar-item>

                        <gg-menu-bar-item
                          v-if="canShowJournalApprove(item)"
                          @click="journalApproveShow(item.id, item.newsletter ? 0 : 1, item)"
                        >
                          <span>Approve</span>
                        </gg-menu-bar-item>

                        <gg-menu-bar-item
                          v-if="canShowJournalRecall(item)"
                          @click="journalRecallShow(item.id, item.newsletter ? 0 : 1, item)"
                        >
                          <span>Recall</span>
                        </gg-menu-bar-item>

                        <gg-menu-bar-item class="hr-class" v-if="canShowJournalMenuDivider(item)">
                          <hr class="hr" />
                        </gg-menu-bar-item>

                        <gg-menu-bar-item
                          v-if="canShowJournalEdit(item)"
                          @click="toEdit(item.id, item.newsletter ? 0 : 1, item)"
                        >
                          <span>Edit</span>
                        </gg-menu-bar-item>

                        <gg-menu-bar-item
                          v-if="canShowJournalDelete(item)"
                          @click="journalDeleteShow(item.id, item.newsletter ? 0 : 1, item)"
                        >
                          <span>Delete</span>
                        </gg-menu-bar-item>
                      </template>
                    </gg-menu-bar>
                  </div>
                </div>
              </div>

              <div class="empty-box" slot="empty" v-else>
                <img :src="require('@/assets/images/moments/empty_photo.png')" />
                <p>No results found.</p>
              </div>
            </div>
          </div>

          <Snackbar :visible.sync="loadingShow" :content="loadingText" />

          <gg-Dialog
            width="580px"
            :visible.sync="journalDeleteSw"
            :title="'Delete ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
            class="draft-dialog mp-dialog"
          >
            <div class="dialogContent">
              Once deleted, you will not be able to recover the
              {{ journalType === 0 ? 'newsletter' : 'portfolio' }} data.
            </div>
            <span slot="footer" class="dialog-footer">
              <gg-cancel-button @click="journalDeleteSw = false">Cancel</gg-cancel-button>
              <gg-submit-button @click="journalDelete">Delete</gg-submit-button>
            </span>
          </gg-Dialog>

          <gg-Dialog
            width="580px"
            :visible.sync="journalSubmitSw"
            :title="'Submit ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
            class="draft-dialog mp-dialog"
          >
            <div class="dialogContent">
              Once submitted, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will be
              subjected to approval for sharing.
            </div>
            <span slot="footer" class="dialog-footer">
              <gg-cancel-button @click="journalSubmitSw = false">Cancel</gg-cancel-button>
              <gg-submit-button @click="journalSubmit">Submit</gg-submit-button>
            </span>
          </gg-Dialog>

          <gg-Dialog
            width="580px"
            :visible.sync="journalUndoSw"
            :title="'Undo submission?'"
            class="draft-dialog mp-dialog"
          >
            <div class="dialogContent">
              Once undone, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will change from
              pending to draft.
            </div>
            <span slot="footer" class="dialog-footer">
              <gg-cancel-button @click="journalUndoSw = false">Cancel</gg-cancel-button>
              <gg-submit-button @click="journalUndo">Undo</gg-submit-button>
            </span>
          </gg-Dialog>

          <gg-Dialog
            width="580px"
            :visible.sync="journalApproveSw"
            :title="'Approve ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
            class="draft-dialog mp-dialog"
          >
            <div class="dialogContent">
              Once approved, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will be shared
              and viewed by parents.
            </div>
            <span slot="footer" class="dialog-footer">
              <gg-cancel-button @click="journalApproveSw = false">Cancel</gg-cancel-button>
              <gg-submit-button @click="journalApprove">Approve</gg-submit-button>
            </span>
          </gg-Dialog>

          <gg-Dialog
            width="580px"
            :visible.sync="journalRecallSw"
            :title="'Recall ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
            class="draft-dialog mp-dialog"
          >
            <div class="dialogContent">
              Once recalled, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will change
              from posted to draft and not be seen by parents.
            </div>
            <span slot="footer" class="dialog-footer">
              <gg-cancel-button @click="journalRecallSw = false">Cancel</gg-cancel-button>
              <gg-submit-button @click="journalRecall">Recall</gg-submit-button>
            </span>
          </gg-Dialog>
        </div>
      </div>
    </GgPage>
  </div>
</template>

<script>
import moment from 'moment'
import { Ajax } from '@/common'
import { ossThumbUrl } from '@/common/ossImage'
import { mapState } from 'vuex'
import { htmlDecode, hasPermission } from './../utils/utils.js'
import { classIdOf, classNameOf } from '@/common/nav-state'
import search from './../modules/search'
import pdfListState, { pdfEditable } from './../utils/pdf-list-state'
export default {
  mixins: [pdfListState],
  components: {
    search
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    })
  },
  data() {
    return {
      pages: 0,
      pageNum: 1,
      loading: false,
      loadingText: '',
      loadingShow: false,
      journalType: 0,
      journalIndex: '',
      journalRecallSw: false,
      journalApproveSw: false,
      journalUndoSw: false,
      journalSubmitSw: false,
      journalDeleteSw: false,
      loadBtn: false,
      list: [],
      query: {}
    }
  },
  watch: {
    $route() {
      this.getJournal()
    }
  },
  created() {
    this.query = this.$route.query || {}
    this.classname = classNameOf(this.$route)
    this.classid = classIdOf(this.$route)
    this.getJournal()
  },
  mounted() {},
  methods: {
    moment,

    hasPermission,

    htmlDecode,

    dateDiff(date) {
      let a = moment.utc(date),
        b = moment()
      return a.diff(b, 'days')
    },

    loadJournal() {
      if (this.pageNum < this.pages && !this.loading) {
        this.getJournal(true)
      }
    },

    isPdfNewsletter(item) {
      return Boolean(
        item &&
        (item.isPdf === true ||
          item.pdfNewsletter === true ||
          item.isPdfNewsletter === true ||
          item.pdfFilePath ||
          (Array.isArray(item.pdfImages) && item.pdfImages.length) ||
          (Array.isArray(item.pdfThumbnailImages) && item.pdfThumbnailImages.length) ||
          (Array.isArray(item.imagePaths) && item.imagePaths.length))
      )
    },

    getPdfThumbnailImages(item) {
      if (!item) return []
      const images = item.pdfThumbnailImages || item.pdfImages || item.imagePaths || []

      if (!Array.isArray(images)) return []
      return images.filter(Boolean).slice(0, 1)
    },

    normalizePdfImagePath(path) {
      if (!path) return ''
      if (/^https?:\/\//i.test(path)) return path
      return `${process.env.VUE_APP_fileBasePath}${path}`
    },

    // 列表卡片 PDF 预览图：按卡片显示框等比缩小（object-fit 场景 → mfit 取样充足）；
    // 详情/PDF 链路仍用 normalizePdfImagePath 原图
    pdfThumbPath(image) {
      return ossThumbUrl(this.normalizePdfImagePath(image), 328, 334, 'mfit')
    },

    getJournalCoverStyle(item) {
      if (this.isPdfNewsletter(item) && this.getPdfThumbnailImages(item).length) {
        return {}
      }

      if (!item || !item.cover) {
        return {}
      }

      return {
        // background-size:cover → mfit 取样充足，浏览器仍按原 CSS 裁切/定位
        backgroundImage: `url(${ossThumbUrl(item.cover, 328, 334, 'mfit')})`
      }
    },

    canShowJournalEdit(item) {
      return Boolean(
        item &&
        (item.status === 'DRAFT' || item.status === 'PENDING') &&
        pdfEditable(item) &&
        !this.isPdfNewsletter(item) &&
        this.hasPermission('Manage journals_Edit')
      )
    },

    canShowJournalMenuDivider(item) {
      return Boolean(
        item &&
        (item.status === 'DRAFT' || item.status === 'PENDING') &&
        (this.canShowJournalEdit(item) || this.canShowJournalDelete(item))
      )
    },

    getJournal(s) {
      let studentName = this.$route.query.studentName,
        studentNameArr =
          studentName && studentName.indexOf(' ') > -1 ? studentName.split(' ') : [studentName],
        data = {
          staffId: this.user.userId,
          keywords: this.$route.query.keywords,
          classId: classIdOf(this.$route),
          studentName: studentNameArr.join(','),
          pageSize: 10
        }

      return this.fetchPdfJournalList(data, s)
    },

    toPreview(id, type, item) {
      let data = {
        id: id
      }
      Ajax.get('journal/' + id, data).then((res) => {
        if (res.code === '0000') {
          const typeName = res.data.newsletter || type === 0 ? 'newsletter' : 'portfolio'
          // 已保存记录：URL 只传 id，view 页自行拉取（不再整包写 storage）
          let url = this.$router.resolve({
            path: '/journal/view?type=' + typeName + '&id=' + encodeURIComponent(res.data.id || id)
          })
          let win = window.open(url.href, '_blank')
          win.onload = function () {
            setTimeout(function () {
              win.document.title = 'Preview'
            }, 100)
          }
        }
      })
    },

    toEdit(id, type, item) {
      this.$router.push({
        name: 'journalCreate',
        query: {
          editid: id,
          type: type,
          classname: this.classname,
          classid: this.classid,
          time: this.moment().valueOf(),
          className: this.classname,
          classId: this.classid,
          year: this.$route.query.year || ''
        }
      })
    },

    journalRecall() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalRecallSw = false
      this.loading = true
      Ajax.put('/journal/' + this.journalIndex + '/recall?staffId=' + this.user.userId)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been recalled'

            setTimeout(() => {
              this.loadBtn = false
              let typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_draft',
                classid = classIdOf(this.$route),
                className = classNameOf(this.$route),
                classId = classIdOf(this.$route),
                year = this.$route.query.year || ''
              this.$router.push(
                '/journal/class/' +
                  classid +
                  '?typename=' +
                  typename +
                  '&className=' +
                  encodeURIComponent(className) +
                  '&classId=' +
                  encodeURIComponent(classId) +
                  '&year=' +
                  encodeURIComponent(year)
              )
            }, 1500)
          } else {
            this.loading = false
            this.loadBtn = false
          }
        })
        .catch(() => {
          this.loading = false
          this.loadBtn = false
        })
    },

    journalRecallShow(id, type, item) {
      this.journalRecallSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalApprove() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalApproveSw = false
      this.loading = true
      Ajax.put(
        '/journal/' +
          this.journalIndex +
          '/process?approve=' +
          true +
          '&staffId=' +
          this.user.userId
      )
        .then((res) => {
          if (res.code === '0000') {
            this.startApprovedPdf(this.journalIndex, this.journalType)
          } else {
            this.loading = false
            this.loadBtn = false
            this.showApprovalError(res)
          }
        })
        .catch((error) => {
          this.loading = false
          this.loadBtn = false
          this.showApprovalError(error)
        })
    },

    journalApproveShow(id, type, item) {
      this.journalApproveSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalUndo() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      Ajax.put('/journal/' + this.journalIndex + '/cancel?staffId=' + this.user.userId).then(
        (res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.journalUndoSw = false
            this.invalidatePdfListRow(this.journalIndex)
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been moved to draft'

            setTimeout(() => {
              this.loadBtn = false
              let typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_draft',
                classid = classIdOf(this.$route),
                className = classNameOf(this.$route),
                classId = classIdOf(this.$route),
                year = this.$route.query.year || ''
              this.$router.push(
                '/journal/class/' +
                  classid +
                  '?typename=' +
                  typename +
                  '&className=' +
                  encodeURIComponent(className) +
                  '&classId=' +
                  encodeURIComponent(classId) +
                  '&year=' +
                  encodeURIComponent(year)
              )
            }, 1500)
          }
        }
      )
    },

    journalUndoShow(id, type, item) {
      this.journalUndoSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalSubmit() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalSubmitSw = false
      this.loading = true
      Ajax.put('/journal/' + this.journalIndex + '/submit?staffId=' + this.user.userId)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been submitted'

            setTimeout(() => {
              this.loadBtn = false
              let typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_pending',
                classid = classIdOf(this.$route),
                className = classNameOf(this.$route),
                classId = classIdOf(this.$route),
                year = this.$route.query.year || ''
              this.$router.push(
                '/journal/class/' +
                  classid +
                  '?typename=' +
                  typename +
                  '&className=' +
                  encodeURIComponent(className) +
                  '&classId=' +
                  encodeURIComponent(classId) +
                  '&year=' +
                  encodeURIComponent(year)
              )
            }, 1500)
          } else {
            this.loading = false
            this.loadBtn = false
          }
        })
        .catch(() => {
          this.loading = false
          this.loadBtn = false
        })
    },

    journalSubmitShow(id, type, item) {
      this.journalSubmitSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalDelete() {
      Ajax.delete('/journal/' + this.journalIndex + '?staffId=' + this.user.userId).then((res) => {
        if (res.code === '0000') {
          this.journalDeleteSw = false
          this.loadingText =
            (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been deleted'
          this.getJournal()
        }
      })
    },

    journalDeleteShow(id, type) {
      this.journalDeleteSw = true
      this.journalIndex = id
      this.journalType = type
    },

    momentTime(date) {
      return moment.utc(date).local().format('DD/MM/YYYY, hh:mm A')
    }
  }
}
</script>
<style>
.journal-pdf-state-tooltip.el-tooltip__popper.is-dark {
  box-sizing: border-box;
  padding: 6px 10px;
  border: 0;
  border-radius: 2px;
  background: #5f6368;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  box-shadow: none;
}
.journal-pdf-generating-tooltip {
  width: 270px;
}
.journal-pdf-failure-tooltip {
  width: 236px;
}
</style>
<style lang="less" scoped>
.journal-list-inner {
  margin: auto;
  width: 1373px;
}

.journal-create-main {
  position: relative;

  .journal-top-fixed {
    width: 1373px;
    background: #fff;

    .journal-people-tag {
      padding: 0 0 10px 0;

      .tag {
        display: inline-block;
        padding: 0 6px 0 4px;
        height: 24px;
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 16px;

        .no {
          display: inline-block;
          margin-right: 8px;
          width: 16px;
          height: 16px;
          background: #b4b4b4;
          border-radius: 50%;
          line-height: 16px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          font-family: 'OpenSans-Bold';
          vertical-align: middle;
        }

        .avatar {
          margin-right: 8px;
          display: inline-block;
          width: 16px;
          height: 16px;
          vertical-align: middle;

          img {
            display: block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
          }
        }

        .name {
          margin-right: 8px;
          display: inline-block;
          font-size: 12px;
          font-family: Roboto;
          font-weight: 400;
          line-height: 16px;
          color: #202124;
          vertical-align: middle;
        }
      }
    }

    .title {
      position: relative;
      margin-top: 0;
      padding-left: 20px;
      padding-bottom: 30px;
      border-bottom: 1px solid #e3e3e3;
      color: #606367;
      font-size: 24px;
      font-family: 'OpenSans-Bold';
    }
  }

  .journal-page-main {
    position: relative;

    .journal-page-list {
      padding-bottom: 112px;
    }
  }
}

.journal-list-box-inner {
  position: relative;
  overflow: hidden;
  padding-top: 20px;
  margin-bottom: 92px;
  margin-right: -48px;

  .journal-box {
    float: left;
    position: relative;
    margin: 0 20px 20px 0;
    width: 328px;
    height: 228px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;

    .journal-col {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }

    .journal-tag {
      display: inline-block;
      margin: 0 0 0 20px;
      padding: 0 5px;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 16px;
      line-height: 22px;
      text-align: left;
      font-family: Roboto;
      font-size: 12px;
      color: #202124;

      .no {
        display: inline-block;
        margin-right: 8px;
        width: 16px;
        height: 16px;
        background: #b4b4b4;
        border-radius: 50%;
        line-height: 16px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        font-family: 'OpenSans-Bold';
        vertical-align: middle;
        overflow: hidden;
      }

      .avatar {
        margin-right: 8px;
        display: inline-block;
        width: 16px;
        height: 16px;
        vertical-align: middle;

        img {
          display: block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
        }
      }

      .name {
        margin-right: 8px;
        display: inline-block;
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        line-height: 16px;
        color: #202124;
        vertical-align: middle;
      }
    }

    .journal-tit {
      margin: 20px 0 10px 20px;
      width: 256px;
      line-height: 20px;
      font-size: 16px;
      text-align: left;
      font-family: Roboto;
      color: #202124;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .pdf-state-badge {
      position: absolute;
      right: 8px;
      top: 8px;
      z-index: 3;
      width: 24px;
      height: 24px;
      border-radius: 100%;
      background: #e5493d;
      color: #fff;
      line-height: 24px;
      text-align: center;

      i {
        font-size: 16px;
        vertical-align: middle;
      }

      &.failed {
        font-family: Roboto, sans-serif;
        font-weight: bold;
        font-size: 20px;
        cursor: default;
      }
    }

    .journal-img {
      display: block;
      position: relative;
      width: 100%;
      height: 136px;
      border-radius: 8px 8px 0 0;
      background-size: cover;
      background-position: top;
      overflow: hidden;

      &.pdf-journal-img {
        background-color: #fff;
        background-size: cover;
        border-bottom: 1px solid #e0e0e0;

        .pdf-chip {
          position: absolute;
          top: 8px;
          right: 8px;
          z-index: 2;
          height: 22px;
          line-height: 22px;
          padding: 0 8px;
          border-radius: 11px;
          background: #1a73e8;
          color: #fff;
          font-size: 12px;
          font-family: Roboto;
        }

        .pdf-thumbnail-pages {
          width: 100%;
          height: 100%;
          box-sizing: border-box;

          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            background: #fff;
          }
        }
      }
    }
  }
}

.journal-inner .empty-box {
  position: fixed;
}
</style>
